import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { AppState } from '../store/app.state';

@Injectable({providedIn: 'root'})
class AuthGuardService  {
  constructor(public auth: AuthService, public router: Router, private appState: AppState) {}
  
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    
    // In iframe SSO mode, allow navigation while SSO is in progress (not idle, not error)
    // The app.component.html will show loading overlay until ssoStatus becomes 'success'
    if (this.appState.iframeLoginMode.value) {
      const ssoStatus = this.appState.ssoStatus.value;
      // While SSO is in progress (initializing, validating), allow activation
      // The overlay is still visible so the user won't interact yet
      if (ssoStatus !== 'idle' && ssoStatus !== 'error' && ssoStatus !== 'success') {
        return true;
      }
      // SSO completed ('success') - fall through to normal checks below (including privacy-policy)
    }

    const user = this.auth.getUserProfile();
    
    if (!user) {
      if (!this.appState.iframeLoginMode.value) {
        this.router.navigate(['/login']);
      }
      return false;
    }
  
    if (!user.privacyPolicyAccepted && state.url !== '/privacy-policy') {
      this.router.navigate(['/privacy-policy']);
      return false;
    }

    return true;
  }
}

export const AuthGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  return inject(AuthGuardService).canActivate(next, state);
}